var _defs, _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDensitiesSelfWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.04 20.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EN 1991-1-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 13.45,
    y: 6.68,
    width: 15.13,
    height: 7.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-911.52-219.86h-1v11h1a2.2,2.2,0,0,0,2.2-2.2v-6.6a2.2,2.2,0,0,0-2.2-2.2h0Zm0,0",
    transform: "translate(951.37 224.51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-916.69-224.51h-4.17v20.82h4.17a2.2,2.2,0,0,0,2.2-2.2v-16.42a2.2,2.2,0,0,0-2.2-2.2h0Zm0,0",
    transform: "translate(951.37 224.51)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-946.2-222.32v16.42a2.2,2.2,0,0,0,2.2,2.2h4.17v-20.82H-944a2.2,2.2,0,0,0-2.2,2.2h0Zm0,0",
    transform: "translate(951.37 224.51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-951.37-217.67v6.6a2.2,2.2,0,0,0,2.2,2.2h1v-11h-1a2.2,2.2,0,0,0-2.2,2.2h0Zm0,5.13",
    transform: "translate(951.37 224.51)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensitiesSelfWeight);
export default __webpack_public_path__ + "static/media/Densities, Self-weight.1beb58db.svg";
export { ForwardRef as ReactComponent };